import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { UiService } from 'src/app/admin/service/ui.service';
import { FiltroUbicacionComponent } from '../filtro-ubicacion/filtro-ubicacion.component';
import { AdminServiceService } from 'src/app/admin/service/admin-service.service';

@Component({
  selector: 'app-filtro-multinivel',
  templateUrl: './filtro-multinivel.component.html',
  styleUrls: ['./filtro-multinivel.component.scss'],
})
export class FiltroMultinivelComponent implements OnInit {
  @ViewChild('popover') popover;
  @Output() filterEmit = new EventEmitter();
  public isOpen = false;
  public ranges = [];
  public filter = {
    country: undefined,
    state: undefined,
    city: undefined,
    range: undefined
  };

  constructor(
    private uiSv: UiService,
    private adminSv: AdminServiceService
  ) { }

  async ngOnInit() {
    const res: any = await this.adminSv.get('range/index', '', '');
    this.ranges = res.data;
  }

  setRange(ev){
    const rangeId = ev.detail.data;
    console.log('ev :>> ', ev);
    this.filter.range = rangeId;
    this.isOpen = false;
    this.filterEmit.emit(this.filter);
  }

  async openFilter(ev){
    try{
      const { data } = await this.uiSv.createPop(FiltroUbicacionComponent, { multi: true }, '', ev);
      console.log('data :>> ', data);
      if(!data) return false;
      this.filter.country = data.country?.id;
      this.filter.state = data.city?.id;
      this.filter.city = data.sector?.id;
  
      this.presentPopover(ev);
    }catch(err){
      console.error(err);
    }
  }

  presentPopover(e: Event) {
    console.log('e :>> ', e);
    this.popover.event = e;
    this.isOpen = true;
  }
}
